import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function WarehouseBin() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [formData, setFormData] = useState({
        warehouse: "",
        bin_name: "",
        bin_code: "",
        aisle: "",
        rack: "",
        shelf: "",
        capacity: "",
        capacity_unit: "TON",
        status: 1,
        addedby: userName,
        ip_add: ipAddress,
    });
    const capacityUnitList = [
        {
            id: "TON",
            name: "TON",
        },
        {
            id: "KG",
            name: "KG",
        },
        {
            id: "BAG",
            name: "BAG",
        },
        {
            id: "LITER",
            name: "LITER",
        },
    ];
    useEffect(() => {
        getWarehouse();
        getWarehouseBin();
    }, []);
    const getWarehouse = () => {
        axios
            .get(baseUrl + "warehouse/")
            .then((res) => {
                setWarehouseList(res.data);
            });
    };
    const getWarehouseBin = () => {
        setLoading(true);
        axios
            .get(baseUrl + "warehouse-bin/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Unable to load warehouse bins.",
                });
            });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const clearForm = () => {
        setFormData({
            warehouse: "",
            bin_name: "",
            bin_code: "",
            aisle: "",
            rack: "",
            shelf: "",
            capacity: "",
            capacity_unit: "TON",
            status: 1,
            addedby: userName,
            ip_add: ipAddress,
        });
    };
    const saveWarehouseBin = () => {
        const data = new FormData();
        data.append("warehouse", formData.warehouse);
        data.append("bin_name", formData.bin_name);
        data.append("bin_code", formData.bin_code);
        data.append("aisle", formData.aisle);
        data.append("rack", formData.rack);
        data.append("shelf", formData.shelf);
        data.append("capacity", formData.capacity);
        data.append("capacity_unit", formData.capacity_unit);
        data.append("status", formData.status);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        setLoading(true);
        axios
            .post(baseUrl + "warehouse-bin/", data)
            .then(() => {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Warehouse Bin saved successfully.",
                });
                clearForm();
                getWarehouseBin();
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Unable to save warehouse bin.",
                });
            });
    };
    const deleteWarehouseBin = (id) => {
        Swal.fire({
            title: "Delete Warehouse Bin?",
            text: "You won't be able to revert this.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(`warehouse-bin/${id}/`)
                    .then(() => {
                        Swal.fire({
                            icon: "success",
                            title: "Deleted",
                            text: "Warehouse Bin deleted successfully.",
                        });
                        getWarehouseBin();
                    })
                    .catch(() => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: "Unable to delete warehouse bin.",
                        });
                    });
            }
        });
    };
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 80,
        },
        {
            field: "warehouse_name",
            headerName: "Warehouse",
            flex: 1,
            renderCell: (params) =>
                params.row?.warehouse_name ||
                params.row?.warehouse?.warehouse_name ||
                "",
        },
        {
            field: "bin_name",
            headerName: "Bin Name",
            flex: 1,
        },
        {
            field: "bin_code",
            headerName: "Bin Code",
            width: 140,
        },
        {
            field: "aisle",
            headerName: "Aisle",
            width: 120,
        },
        {
            field: "rack",
            headerName: "Rack",
            width: 120,
        },
        {
            field: "shelf",
            headerName: "Shelf",
            width: 120,
        },
        {
            field: "capacity",
            headerName: "Capacity",
            width: 120,
        },
        {
            field: "capacity_unit",
            headerName: "Unit",
            width: 100,
        },
        {
            field: "status",
            headerName: "Status",
            width: 100,
            renderCell: (params) =>
                params.value === 1 ? "Active" : "Inactive",
        },
    ];
    return (
        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Warehouse Bin Master
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-4 mb-3">

                            <label>Warehouse</label>

                            <select
                                className="form-select"
                                name="warehouse"
                                value={formData.warehouse}
                                onChange={handleChange}
                            >

                                <option value="">
                                    Select Warehouse
                                </option>

                                {warehouseList.map((item) => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.warehouse_name}
                                    </option>
                                ))}

                            </select>

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Bin Name</label>

                            <input
                                type="text"
                                className="form-control"
                                name="bin_name"
                                value={formData.bin_name}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Bin Code</label>

                            <input
                                type="text"
                                className="form-control"
                                name="bin_code"
                                value={formData.bin_code}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Aisle</label>

                            <input
                                type="text"
                                className="form-control"
                                name="aisle"
                                value={formData.aisle}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Rack</label>

                            <input
                                type="text"
                                className="form-control"
                                name="rack"
                                value={formData.rack}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Shelf</label>

                            <input
                                type="text"
                                className="form-control"
                                name="shelf"
                                value={formData.shelf}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Capacity</label>

                            <input
                                type="number"
                                className="form-control"
                                name="capacity"
                                value={formData.capacity}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Unit</label>

                            <select
                                className="form-select"
                                name="capacity_unit"
                                value={formData.capacity_unit}
                                onChange={handleChange}
                            >

                                {capacityUnitList.map((item) => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>
                                ))}

                            </select>

                        </div>

                        <div className="col-md-2 mb-3">

                            <label>Status</label>

                            <select
                                className="form-select"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >

                                <option value={1}>
                                    Active
                                </option>

                                <option value={0}>
                                    Inactive
                                </option>

                            </select>

                        </div>

                        <div className="col-md-12 mt-3">

                            <button
                                className="btn btn-success me-2"
                                onClick={saveWarehouseBin}
                                disabled={loading}
                            >
                                Save
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </div>
                    <div className="card shadow mt-3">

                        <div className="card-header bg-primary text-white">

                            <h5 className="mb-0">
                                Warehouse Bin List
                            </h5>

                        </div>

                        <div className="card-body">

                            <div
                                style={{
                                    height: 600,
                                    width: "100%",
                                }}
                            >

                                <ERPDataGrid
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    getRowId={(row) => row.id}
                                    pageSizeOptions={[
                                        10,
                                        25,
                                        50,
                                        100,
                                    ]}
                                    
                                    disableRowSelectionOnClick
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}
export default WarehouseBin;